import { render, staticRenderFns } from "./OtherSpeciesData.vue?vue&type=template&id=0fe7c1b4&"
import script from "./OtherSpeciesData.vue?vue&type=script&lang=js&"
export * from "./OtherSpeciesData.vue?vue&type=script&lang=js&"
import style0 from "./OtherSpeciesData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports